<template>
<div id="wrapper">
  <section class="not_found">
    <div class="title-404">
       <p><img src="@/static/images/404.png" alt="404 error"></p>
    </div>
    <p class="go_home"><a :href="constants.MATCHA_SITE ">{{$t('Return to Home Page')}}</a></p>
  </section>
  <!--end .center -->
</div>
  <!-- <div>
    <section class="Landscape">
      <h1 class="Landscape__Title">
          404
      </h1>
      <h2 class="Landscape__SubTitle">
        {{$t('Page not found!')}}
      </h2>
      <ul class="Landscape__List">
        <li class="Landscape__List__Item">
          <a class="button button--green" :href="'/'"> {{$t('Home')}} </a>
        </li>
      </ul>
    </section>
    <nuxt-footer></nuxt-footer>
  </div> -->
</template>

<script>
import MainHeader from '@/components/common/Header'
import MainFooter from '@/components/common/Footer'
import * as constants from '@/constants'

export default {
  props: ['error'],
  components: {
    MainHeader,
    MainFooter
  },
  data: () => {
    return {
      constants: constants,
    }
  }
}
</script>

<style lang="scss" scoped>
  body{
    background-color: white;
  }
  .not_found{
    margin: 0 auto;
    color: black;
    text-align: center;
    width: 572px;
    padding-bottom: 40px;
    max-width: 100%;
  }
  .go_home a{
    border-radius: 3px;
    background: #a3b01e;
    padding: 8px 40px;
    color: white;
    text-decoration: none;
    display: inline-block;
  }
  .title-404 {
    font-size: 50px;
    font-weight: bold;
    margin: 24px 0 16px;
  }
  .content-404 {
    font-size: 20px;
  }

</style>


// WEBPACK FOOTER //
// src/components/NotFound.vue